import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Cinema } from '../models';
import { LocationFilterService } from '../services/location-filter.service';

@Component({
  selector: 'app-compact-cinema-row',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <a class="compact-row cinema-row" *ngIf="cinema" [routerLink]="['/cinemas', cinema.id]" queryParamsHandling="preserve">
      <span class="chain-mark">{{ cinema.chain.slice(0, 2).toUpperCase() }}</span>
      <span class="row-main">
        <strong>{{ cinema.name }}</strong>
        <small>{{ cinema.chain }} · {{ cinema.city }}, {{ cinema.county }}<span *ngIf="distanceLabel()"> · {{ distanceLabel() }}</span></small>
      </span>
      <span class="row-action">Open</span>
    </a>
  `,
  styles: [
    `
      .compact-row {
        min-height: 68px;
        padding: 9px;
        border: 1px solid var(--line);
        border-radius: 16px;
        background: var(--surface-row);
        box-shadow: 0 10px 28px rgba(0,0,0,.16);
        display: grid;
        grid-template-columns: 46px minmax(0, 1fr) auto;
        gap: 11px;
        align-items: center;
      }

      .chain-mark {
        width: 46px;
        height: 46px;
        border-radius: 14px;
        display: grid;
        place-items: center;
        color: var(--text);
        background: linear-gradient(135deg, var(--red), var(--violet), var(--blue));
        font-size: 14px;
        font-weight: 950;
      }

      .row-main {
        min-width: 0;
        display: grid;
        gap: 5px;
      }

      .row-main strong {
        color: var(--text);
        font-size: 15px;
        line-height: 1.15;
        overflow-wrap: anywhere;
      }

      .row-main small {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--muted);
        font-size: 12px;
        font-weight: 800;
      }

      .row-action {
        min-height: 40px;
        border-radius: 12px;
        padding: 0 12px;
        display: grid;
        place-items: center;
        color: var(--cyan);
        background: var(--control-bg);
        font-size: 13px;
        font-weight: 950;
      }

      @media (max-width: 420px) {
        .compact-row {
          grid-template-columns: 42px minmax(0, 1fr) 54px;
          gap: 8px;
        }

        .chain-mark {
          width: 42px;
          height: 42px;
          border-radius: 13px;
        }

        .row-action {
          padding: 0 8px;
        }
      }
    `,
  ],
})
export class CompactCinemaRowComponent {
  @Input({ required: true }) cinema!: Cinema;

  constructor(private readonly location: LocationFilterService) {}

  distanceLabel(): string {
    return this.location.formatDistance(this.cinema);
  }
}
